module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimers"
  }, [_c('h2', [_c('Icon', {
    attrs: {
      "icon": "disclaimer"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm._translate('disclaimers.title'))
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "disclaimers__container"
  }, [_c('div', {
    staticClass: "disclaimers__wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.outputDisclaimers)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disclaimers__wrapper"
  }, [_c('p', {
    staticClass: "disclaimers__item"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm._translate('disclaimers.copyright'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm._translate('links.disclaimers'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._translate('disclaimers.disclaimers')))]), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm._translate('links.legal'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._translate('disclaimers.legalText')))]), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm._translate('links.privacy'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._translate('disclaimers.privacyText')))]), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm._translate('links.complaint'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._translate('disclaimers.complaintText')))])]), _c('p', {
    staticClass: "disclaimers__item disclaimers__item--italic",
    domProps: {
      "innerHTML": _vm._s(_vm._translate('disclaimers.general'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "disclaimers__item disclaimers__item--italic",
    domProps: {
      "innerHTML": _vm._s(_vm._translate('disclaimers.general2'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "disclaimers__control"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.acceptDisclaimers()
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('disclaimers.acceptButton')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d244f0a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Disclaimers.vue
// module id = 334
// module chunks = 0